import { render, staticRenderFns } from "./AnalisaSidebar.vue?vue&type=template&id=20c88d15&scoped=true&"
import script from "./AnalisaSidebar.vue?vue&type=script&lang=js&"
export * from "./AnalisaSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AnalisaSidebar.vue?vue&type=style&index=0&id=20c88d15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c88d15",
  null
  
)

export default component.exports